<template>
  <ValidationObserver ref="dialogObserver">
    <AppDialog
      show
      title="Custom roles"
      append-to-body
      class="organization-settings-permissions custom-permissions-dialog"
      @close="$emit('close')"
    >
      <template #titleLabel>
        <span class="text-uppercase bg-bright-purple rounded-corners small is-bold ml-10 p-5">
          Feedback
        </span>
      </template>

      <div class="pb-15">
        Tell us what role permissions features would make the biggest difference for your team.
      </div>

      <h4>What job types would you like to set custom permissions for?</h4>
      <ValidationProvider
        v-slot="{ errors }"
        rules="required"
      >
        <div
          class="form-group group-job-types"
          :class="{ 'has-error': !!errors?.length }"
        >
          <label class="control-label">Job Types</label>
          <textarea
            v-model="payload.job_types"
            class="form-control"
            name="job_types"
            placeholder="Finance, HR, etc."
          ></textarea>
          <span class="help-block">{{ errors[0] }}</span>
        </div>
      </ValidationProvider>

      <h4>Which additional permissions would you like to customize?</h4>
      <div class="form-group permission-types">
        <button
          v-for="(label, key) in permissionTypes"
          :key="key"
          type="button"
          :name="key"
          class="text text-grey btn is-regular mb-10 mr-10"
          :class="{ selected: isSelectedPermission(key) }"
          @click="toggle(key)"
        >
          {{ label }}
        </button>
      </div>
      <ValidationProvider
        v-slot="{ errors }"
        :rules="payload.selected_permissions.length ? '' : 'required'"
        :custom-messages="{ required: 'at least one permission must be selected or other must be filled in.' }"
      >
        <div
          class="form-group group-other"
          :class="{ 'has-error': !!errors?.length }"
        >
          <label class="control-label">Other</label>
          <textarea
            v-model="payload.other"
            class="form-control"
            name="other"
            placeholder="Let us know what other features you would like to customize"
          ></textarea>
          <span class="help-block">{{ errors[0] }}</span>
        </div>
      </ValidationProvider>

      <template #footer>
        <div class="justify-content-end">
          <AppButton
            type="default"
            @click="$emit('close')"
          >
            Close
          </AppButton>
          <AppButton
            type="primary"
            @click="submitData"
          >
            Submit
          </AppButton>
        </div>
      </template>
    </AppDialog>
  </ValidationObserver>
</template>

<script>
export default {
  props: {
    organizationId: {
      type: Number,
      required: true,
    },
    currentUserId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      testData: true,
      payload: {
        job_types: '',
        other: '',
        selected_permissions: [],
      },
      permissionTypes: {
        inviteTeamMembers: 'Invite team members',
        createTeams: 'Create teams',
        createProjects: 'Create projects',
        payInvoices: 'Pay invoices',
        manageBilling: 'Manage billing',
        view_insights: 'View insights',
        approveTimeOffRequest: 'Approve time off request',
        sendPayments: 'Send payments/payroll',
      },
    };
  },
  methods: {
    toggle(key) {
      this.payload.selected_permissions.includes(key)
        ? (this.payload.selected_permissions = this.payload.selected_permissions.filter((item) => item !== key))
        : this.payload.selected_permissions.push(key);
    },
    isSelectedPermission(key) {
      return this.payload.selected_permissions.includes(key);
    },
    submitData() {
      this.$refs.dialogObserver.validate().then((result) => {
        if (!result) {
          return;
        }

        if (window.analytics) {
          window.analytics.track('Custom role feedback added', {
            ...this.payload,
            organization_id: this.organizationId,
            user_id: this.currentUserId,
          });
          this.$appMessage(
            'The information was sent to our team and will be taken into consideration when creating the feature!',
            {
              header: '<i class="fa fa-info-circle"></i> Thank you for your feedback',
            },
          );
          this.$emit('close');
        } else {
          this.$appMessage('An error occurred. Please contact the administrator!');
        }
      });
    },
  },
};
</script>
